import axios from 'axios'
import { useRouter } from 'vue-router'
import _ from 'lodash'
import { boot } from 'quasar/wrappers'
import checkStatus from 'src/common/helpers/functions/checkStatus'
import { useAuthStore } from 'src/stores'

const authStore = useAuthStore()
const router = useRouter()
// const generalStore = useGeneralStore()

/* ----------------------------- Gateway Client ----------------------------- */
const gatewayClient = axios.create({
  baseURL: process.env.GATEWAY_BASE_URL,
  method: 'POST',
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

/* ----------------------------- Gateway Client ----------------------------- */
const mainClient = axios.create({
  baseURL: process.env.MAIN_BASE_URL,
  method: 'POST',
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

/* ------------------------------- All Clients ------------------------------ */
const clients = [
  { name: 'gatewayClient', wrap: gatewayClient },
  { name: 'mainClient', wrap: mainClient },
]

const api = axios.create({ baseURL: 'https://api.example.com' })

export default boot(({ app }) => {
  /* -------------------------------------------------------------------------- */
  /*                                   Request                                  */
  /* -------------------------------------------------------------------------- */
  clients.forEach((client) => {
    client.wrap.interceptors.request.use((request) => {
      if (process.env.CLIENT && authStore.token) {
        request.headers.Authorization = `Bearer ${authStore.token}`
      }
      return request
    })
  })

  /* -------------------------------------------------------------------------- */
  /*                                  Response                                  */
  /* -------------------------------------------------------------------------- */
  clients.forEach((client) => {
    client.wrap.interceptors.response.use(
      (response) => {
        checkStatus(response.status)

        // let portalVersion = response.data.portal_version
        // if (!portalVersion) return response
        // else portalVersion = portalVersion.split('.').join('')

        // const newVersion = Number(portalVersion)
        // const lastVersion = generalStore.portalVersion

        // console.log('axios', { newVersion, lastVersion })

        // if (!lastVersion || lastVersion < newVersion) {
        //   generalStore.portalVersion = newVersion
        //   process.env.CLIENT && location.reload()
        // }

        if ('data' in response.data) {
          response.meta = _.omit(response.data, ['data'])
          response.data = response.data.data
        } else response.meta = {}

        return response
      },
      (error) => {
        checkStatus(error.response.status, router)
        throw error
      },
    )
  })

  app.config.globalProperties.$axios = axios
  app.config.globalProperties.$api = api
  app.config.globalProperties.$gatewayClient = gatewayClient
  app.config.globalProperties.$mainClient = mainClient
})

export { api, gatewayClient, mainClient }
